import VideoOptions from "./video_options"
import FirstVideoCelebration from "./first_video_celebration"
import vimeo_manager from "vimeo_manager"
import {track_consumed_video} from "consumed_content"
import React from "react"
import modal from "../modal"

function EmbeddedVideo({
  title,
  html_title,
  auto_play,
  play_time,
  description,
  transcript,
  timestamps,
  vimeo_id,
  vimeo_thumbnail_url,
  small_vimeo_thumbnail_url,
  can_watch_full_video,
  restricted,
  language,
  tracking_data,
  show_content_tabs,
  start_time
}) {
  const [iframe, set_iframe] = React.useState()
  const [load_vimeo_player, set_load_vimeo_player] = React.useState(auto_play)
  const [
    is_video_options_visible,
    set_is_video_options_visible
  ] = React.useState(false)
  const [
    show_first_video_celebration,
    set_show_first_video_celebration
  ] = React.useState(undefined)
  use_vimeo_video(
    tracking_data.slug,
    iframe,
    set_is_video_options_visible,
    set_show_first_video_celebration,
    start_time,
    auto_play
  )
  function on_click() {
    if (restricted) return modal("#reg_wall_modal")

    set_load_vimeo_player(true)
  }
  React.useEffect(() => {
    if (start_time) {
      set_load_vimeo_player(true)
    }
  }, [start_time])
  const iframe_src =
    `https://player.vimeo.com/video/${vimeo_id}` +
    `?autoplay=1&muted=${auto_play ? 1 : 0}`
  return (
    <div className="embedded-video">
      <div className="embedded-video--video">
        {!load_vimeo_player &&
          <picture>
            <source
              srcSet={small_vimeo_thumbnail_url}
              media="(max-width: 479px)"
            />
            <img alt="" src={vimeo_thumbnail_url} onClick={on_click} />
          </picture>}
        {load_vimeo_player &&
          <iframe
            src={iframe_src}
            id={`videos_vimeo_player_${vimeo_id}`}
            data-video-tracking={JSON.stringify(tracking_data)}
            data-video-language={language}
            ref={set_iframe}
            webkitallowfullscreen=""
            mozallowfullscreen=""
            allowFullScreen={true}
            frameBorder="0"
            allow="autoplay"
            height="9"
            width="16"
          />}
      </div>
      {show_first_video_celebration &&
        <FirstVideoCelebration
          on_close={() => set_show_first_video_celebration(false)}
        />}
      {!show_first_video_celebration && is_video_options_visible &&
        <VideoOptions
          vimeo_id={vimeo_id}
          iframe={iframe}
          timestamps={timestamps}
          transcript={transcript}
          can_watch_full_video={can_watch_full_video}
          show_content_tabs={show_content_tabs}
        />}
      {!show_first_video_celebration && !is_video_options_visible &&
        <div className="embedded-video--content">
          <div className="embedded-video--title">
            {html_title || `${title} [${play_time}]`}
          </div>
          <div className="embedded-video--description">{description}</div>
        </div>}
    </div>
  )
}

let first_video_consumed = false

function use_vimeo_video(
  slug,
  iframe,
  set_is_video_options_visible,
  set_show_first_video_celebration,
  start_time,
  auto_play
) {
  React.useEffect(() => {
    if (!iframe) return

    vimeo_manager.init_player(iframe, {
      on_update_time: (data) => {
        if (!window.gon.current_user) return
        if (window.gon.current_user.videos_consumed_count > 0) {
          return
        }
        const percentage_viewed = data?.percent || 0.0
        if (percentage_viewed <= 0.85) return
        if (first_video_consumed) return
        first_video_consumed = true
        set_show_first_video_celebration(true)
      }
    })
    set_is_video_options_visible(true)
    track_consumed_video(slug, iframe)

    if (start_time) {
      vimeo_manager.play_video(iframe, start_time)
    }

    if (auto_play) {
      document.addEventListener("click", () => {
        vimeo_manager.unmute(iframe)
      }, {once: true})
    }
  }, [iframe, start_time])
}

export default EmbeddedVideo
